<template>
  <QuillEditor
    :key="props.id"
    :id="props.field"
    :data-cy="props.id.split('_')[1] + '-' + props.field"
    v-bind="$attrs"
    ref="inputField"
    :content="value"
    theme="snow"
    content-type="html"
    :hide-spin-buttons="true"
    :label="label || t(`entities.${type}.fields.${field}`)"
    :readOnly="readonly"
    :class="{ occupied: isOccupied }"
    role="CalcInput"
    @update:content="onChange"
    @wheel="">
    <!--TODO readonly not clickable-->
    <template
      v-if="props.icon"
      #prepend>
      <icon-loader :name="props.icon" />
    </template>
    <v-avatar
      size="20"
      v-if="isOccupied"
      color="primary"
      style="position: fixed; right: 10px; top: 10px; font-size: 12px">
      {{ mainStore.getInitials(isOccupied) }}
    </v-avatar>
  </QuillEditor>
</template>

<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import IconLoader from "@/components/tools/IconLoader.vue";
import { useMainStore } from "@/stores/mainStore";
import { useSpaceStore } from "@/stores/spaceStore";
import { computed } from "vue";
import { useSocketStore } from "@/stores/socketStore";

const copyName = () => {
  navigator.clipboard.writeText(`,"${props.field}"`);
};

const mainStore = useMainStore();
const spaceStore = useSpaceStore();
const socketStore = useSocketStore();

const { t } = useTranslation();

const isOccupied = computed(() => {
  return mainStore.occupiedFields[props.id]?.[props.field];
});

const value = computed(() => {
  return spaceStore.calculationElements[props.id][props.field];
});

function watchFocus(value: boolean) {
  if (isOccupied.value) {
    return;
  }

  console.log("Focus changed to", value);

  if (value) {
    socketStore.socket.emit("element-focus", props.id, props.field);
  } else if (!value) {
    socketStore.socket.emit("element-blur", props.id, props.field);
  }
}

function onChange(value: string) {
  spaceStore.calculationElements[props.id][props.field] = value;
  spaceStore.updateElement(props.id, [props.field]);
  socketStore.socket.emit("field-input", props.id, props.field, value);
}

const readonly = computed(() => {
  return spaceStore.readOnly || isOccupied.value;
});

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  field: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    default: null
  },
  label: {
    type: String,
    default: null
  }
});

const [_, type] = props.id.split("_");
</script>
<style scoped lang="scss">
.occupied {
  /* background-color: #f0f0f0; */
  opacity: 0.3;
  pointer-events: none;
}
</style>
